import Logo1 from 'assets/images/testimonials/logo1.png';
import Logo2 from 'assets/images/testimonials/logo2.png';
import Logo3 from 'assets/images/testimonials/logo3.png';
import Logo4 from 'assets/images/testimonials/logo4.png';
import Logo5 from 'assets/images/testimonials/logo5.png';

type Logos = {
  Logo1: string;
  Logo2: string;
  Logo3: string;
  Logo4: string;
  Logo5: string;
};

export const logos: Logos = { Logo1, Logo2, Logo3, Logo4, Logo5 };

export type Testimonials = {
  text: string;
  name: string;
  job: string;
};

export const testimonials: Testimonials[] = [
  {
    text: " “Creative design, enough space, sufficient lighting, Efficiently laidout equipments, quality flooring, multipurpose facilities, well maintained and clean, supportive staff, competent trainers, easily accessible location, great amenities.”",
    name: 'Sapna Kataria',
    job: 'Local Guide',
  },
  {
    text: ' “The gym has all equipment’s and the staff and trainer is friendly and helpful. The gym is kept  clean and tidy machines are maintained regularly they have covered all the category in fitness.I enjoy every second of it being there for a workout ”',
    name: 'Priyanka Tomar',
    job: 'S$P Analyst',
  },
  {
    text: " “Very familiar and well maintained gym that I've ever seen. Very comfortable lighting, neat and clean equipments. Trainers are also certified and they are very well behaving. Surrounding area is also very calm and nature friendly.”",
    name: 'Lokesh Sharma',
    job: 'President- NRI Residency',
  },
];
